import { kebabCase, pascalCase } from 'change-case';
import * as Icons from 'lucide-react';
export const FALLBACK_NAVIGATION_ICON = 'dot-icon';
export const ALLOWED_ICON_NAMES = Object.keys(Icons)
    .filter(it => !['default', 'icons', 'createLucideIcon'].includes(it) && it.endsWith('Icon'))
    .map(it => kebabCase(it));
export const getIconName = (icon) => {
    return `${pascalCase(icon)}Icon`;
};
export const isLucideIcon = (icon) => {
    const iconName = kebabCase(icon);
    return ALLOWED_ICON_NAMES.includes(iconName.endsWith('-icon') ? icon : `${icon}-icon`);
};
//# sourceMappingURL=lucide-icons.js.map